import React, { useEffect, useRef, useState } from "react";
import BPService from "../../services/resource/bpService";
import Modal from "../../componentes/modal/modal";
import BPPageTabela from "./MeuBpTabela";
import { formatarMoedaBrasileira } from "../../utils/formatarMoedaBrasileira";
import { useAuth } from "../../context/authContext";
import CadastroBP from "./CadastroBP";
import { toast } from "react-toastify";

import { Dialog } from 'primereact/dialog'
import { InputNumber } from "primereact/inputnumber";
import { LineChartOrcadoRealizadoApex } from "./relatorios-meubp/LineChartOrcadoRealizado";
import { PieTotalOrcadoRealizadoApex } from "./relatorios-meubp/PieTotalOrcadoRealizadoApex";
import ImportarBPModal from "./ImportarBPModal";
import DashboardResumoMeuBP from "./dashboards/DashboardResumoMeuBP";
import SplitButton from "../../componentes/button-split/SplitButton";
import { Loading } from "../../componentes/loading/loading";
import { returnDate } from "../../utils/formatDate";
import DespesaService from "../../services/resource/DespesaService";
import PageAPI from "../../componentes/pagination/Pagination-Page";
import MeuBPRelatorio from "./MeuBPRelatorio";
import MeuBPDashboard from "./MeuBPDashboard";
import { Filtros } from "./MeuBPFiltros";
import Button from "../../componentes/button/button";

const initialBP = {
  content: [],
  page: {
    "size": 20,
    "number": 0,
    "totalElements": 0,
    "totalPages": 0
  }
}

export default function BPPage() {
  const service = new BPService();
  const despesaService = new DespesaService();

  const inputDistribuirRef = useRef(null);
  const { user } = useAuth();

  const [selectedFilters, setSelectedFilters] = useState({
    centroCusto: [],
    contaContabil: [],
    filial: [],
    tipo: [],
    modo: [],
    usuarioCompartilhado: [],
    status: [],
    responsavel: [user.nome],
    ano: 2026
  });

  const [bplist, setBpList] = useState(initialBP);
  const [bpRelatorio, setBpRelatorio] = useState(initialBP);
  const [listaDespesa, setListaDespesa] = useState([]);
  const [selectedBP, setSelectedBP] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalDespesa, setShowModalDespesa] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalImport, setShowModalImport] = useState(false);
  const [showDistribuir, setShowDistribuir] = useState(false);
  const [valorDistribuir, setValorDistribuir] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingImport, setLoadingImport] = useState(false);
  const [relatorio, setRelatorio] = useState({});
  const [nota, setNota] = useState([]);
  const [mensagemImportacao, setMensagemImportacao] = useState("");
  const [viewMode, setViewMode] = useState("lista");
  const [loadingDespesa, setLoadingDespesa] = useState(false)

  const [filtros, setFiltros] = useState({
    "centroCusto": [],
    "contaContabil": [],
    "filial": [],
    "responsavel": [user.nome],
    "tipo": [],
    "status": [],
    "modo": [],
    "usuarioCompartilhado": [],
    "ano": 2026
  });

  const [page, setPage] = useState({
    page: 0,
    size: 20,
    sortKey: "id",
    sortDirection: "desc"
  });

  const [sortConfig, setSortConfig] = useState({
    key: "id",
    direction: "asc",
  });

  const handleSort = (key) => {
    // decide a próxima direção com base no sortConfig atual
    const nextDirection =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";

    // atualiza sortConfig (para UI, setinhas etc.)
    setSortConfig({
      key,
      direction: nextDirection,
    });

    // atualiza paginação & sort para a API
    setPage((prev) => ({
      ...prev,
      page: 0,               // opcional: volta para primeira página ao ordenar
      sortKey: key,
      sortDirection: nextDirection,
    }));
  };

  const MESES = [
    "JANEIRO", "FEVEREIRO", "MARCO", "ABRIL", "MAIO", "JUNHO",
    "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO",
  ];

  useEffect(() => {
    fetchFiltros();
    document.title = "MyDash | Gerenciamento BP"
  }, []);

  useEffect(() => {
    fetchBp();
  }, [selectedFilters, page, sortConfig]);

  useEffect(() => {
    fetchRelatorio();
  }, [
    selectedFilters.centroCusto,
    selectedFilters.contaContabil,
    selectedFilters.filial,
    selectedFilters.tipo,
    selectedFilters.modo,
    selectedFilters.usuarioCompartilhado,
    selectedFilters.status,
    selectedFilters.ano
  ]);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, [showModal]);

  const fetchBp = () => {
    setLoading(true);
    service.listarMinhasContas(selectedFilters, page, user.sub).then(res => {
      setBpList(res.data)
    }).finally(() => setLoading(false))
  }

  const fetchFiltros = () => {
    service.filtrosPorUsuario(user.sub).then(response => {
      setFiltros(response.data);

      setSelectedFilters(prev => ({
        ...prev,
        responsavel: [...prev.responsavel, response.data.usuariosCompartilhadores] // adiciona ao array existente
      }));

    }).catch(error => {
      console.error(error)
    })
  };

  const fetchRelatorio = () => {
    setLoading(true);
    service.relatorioMeuBP(selectedFilters).then(res => {
      setBpRelatorio(res.data)
    }).finally(() => setLoading(false));
  }

  // 🔹 Abre o modal e combina os dados de 2025 e 2026
  const openModal = (row) => {
    const valores2025 = row.valoresMensaisAnterior || {};
    const valores2026 = row.valoresMensais || {};
    const despesasMensais = row.despesasMensais || {};

    const comparativo = MESES.reduce((acc, mes) => {
      acc[mes] = {
        valor2025: valores2025[mes] || 0,
        valor2026: valores2026[mes] || 0,
        realizado2025: despesasMensais[mes] || 0
      };
      return acc;
    }, {});

    const total2025 = Object.values(valores2025).reduce((a, b) => a + (b || 0), 0);
    const total2026 = Object.values(valores2026).reduce((a, b) => a + (b || 0), 0);

    setSelectedBP({ ...row, comparativo, total2025, total2026 });
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedBP(null);
    setShowModal(false);
    setRelatorio({})
  };

  const formatNumber = (value) => {
    if (!value) return "";
    return new Intl.NumberFormat("pt-BR").format(value);
  };

  const desmarcarOrcamento = () => {
    service.desmarcaContaOrcada(selectedBP.id).then(res => {

      const list = [...bplist]; // cria uma cópia da lista original
      const indexof = list.findIndex(item => item.id == selectedBP.id);

      if (indexof !== -1) {
        list[indexof] = res.data; // atualiza o item com os dados retornados
        setBpList(list);
        setShowModal(false);
      } else {
        console.warn("Item não encontrado na lista.");
      }

      closeModal();
    }).catch(error => {
      console.error(error);
    })
  }

  // 🔹 Atualiza valores mensais de 2026 no modal e recalcula totais
  const handleChangeValor2026 = (mes, novoValor) => {
    setSelectedBP((prev) => {
      const comparativoAtualizado = {
        ...prev.comparativo,
        [mes]: {
          ...prev.comparativo[mes],
          valor2026: novoValor,
        },
      };

      const total2026 = Object.values(comparativoAtualizado).reduce(
        (acc, item) => acc + (item.valor2026 || 0),
        0
      );
      const total2025 = Object.values(comparativoAtualizado).reduce(
        (acc, item) => acc + (item.valor2025 || 0),
        0
      );

      return {
        ...prev,
        comparativo: comparativoAtualizado,
        total2026,
        total2025,
      };
    });
  };

  const handleSave = async () => {
    if (!selectedBP) return;
    setSaving(true);

    const payload = {
      id: selectedBP.id,
      ano: 2026,
      valoresMensais: Object.fromEntries(
        Object.entries(selectedBP.comparativo).map(([mes, dados]) => [
          mes,
          dados.valor2026,
        ])
      ),
    };

    service.atualizarValoresMensais(payload).then(res => {
      const list = [...bplist.content]; // cria uma cópia da lista original
      const indexof = list.findIndex(item => item.id == selectedBP.id);

      if (indexof !== -1) {
        list[indexof] = res.data; // atualiza o item com os dados retornados
        setBpList(prev => ({ ...prev, content: list }));
        setShowModal(false);
      } else {
        console.warn("Item não encontrado na lista.");
      }
      fetchRelatorio();
    }).catch(err => {
      console.error("Erro ao salvar alterações: ", err);
    }).finally(() => {
      setSaving(false);
    });
  };

  const FileDownload = require('js-file-download');

  const exportarExcel = (selectedFilters) => {
    service.exportExcelPorAno({
      ano: 2026,
      centroCusto: selectedFilters.centroCusto,
      contaContabil: selectedFilters.conta,
      filial: selectedFilters.filial,
      responsavel: [user.nome],
      email: [user.sub]
    }).then(response => {
      FileDownload(response.data, "BP " + user.nome + ".xlsx");
    }).catch(error => {
      console.error(error.message);
    })
  }

  function importarExcel(e) {
    setLoadingImport(true);
    const file = e.files[0];
    const formData = new FormData();
    formData.append("file", file);

    service.importarExcel(formData, user.id)
      .then((res) => {
        setMensagemImportacao(res);
        fetchBp();
      })
      .catch(() => console.error("Erro ao importar planilha."))
      .finally(() => {
        setLoadingImport(false);
      });
  }

  function marcarComoOrcado() {
    setLoading(true);
    service.marcarComoOrcado(user.id, 2026)
      .then(response => {
        fetchBp(); // Atualiza a lista
        toast.success(`Marcação concluída! ${response.data.registrosAlterados} registros alterados.`);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  function desmarcarComoOrcado() {
    setLoading(true);
    service.desmarcarComoOrcado(user.id, 2026)
      .then(response => {
        fetchBp(); // Atualiza a lista
        toast.success(`Desmarcação concluída! ${response.data.registrosAlterados} registros alterados.`);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  const fecharModal = () => {
    setShowModalDespesa(false);
    setListaDespesa([]);
    setViewMode('lista')
  }

  const abrirModal = () => {
    setShowModalDespesa(true);

    setLoadingDespesa(true);

    despesaService.listaDespesas(2025, selectedBP.filialNome, selectedBP.centroCustoCodigo, selectedBP.contaCodigo).then(response => {
      setListaDespesa(response.data);
    }).finally(() => {
      setTimeout(() => {
        setLoadingDespesa(false);
      }, 300)
    });
  }

  const abrirNotaCompleta = (historico, data) => {
    setLoadingDespesa(true);
    despesaService.listaPorHistorico({
      historico: historico,
      data: data
    }).then(res => {
      setNota(res.data);
      setViewMode("nota");
    }).finally(() => setLoadingDespesa(false));
  };

  const voltarLista = () => {
    setViewMode("lista");
    setNota([]);
  };

  const valorTotalDespesa = listaDespesa.reduce(function (acumulador, obj) {
    return acumulador + obj.valor;
  }, 0);

  return (
    <div className="bg-background min-h-screen p-6">
      <div className="bg-card rounded-xl shadow-card overflow-hidden pb-3">

        <MeuBPRelatorio
          title="BP 2026"
          subtitle="Orçamentos de Contas para BP 2026"
          data={bpRelatorio}
          loading={loading}
        />

        <MeuBPDashboard
          data={bpRelatorio}
          service={service}
          loading={loading}
          filters={selectedFilters}
          usuario={user.nome}
        />

        <div className="pb-2 pt-2 px-3">
          <Filtros
            data={filtros}
            filters={selectedFilters}
            onFiltersChange={setSelectedFilters}
            usuario={user.nome}
          />
        </div>

        <BPPageTabela data={bplist}
          openModal={openModal}
          loading={loading}
          onModalExcel={() => setShowModalImport(true)}
          exportarPlanilha={exportarExcel}
          marcarComoPendente={desmarcarComoOrcado}
          marcarComoRealizado={marcarComoOrcado}
          service={service}
          fetch={fetchBp}
          usuario={user}
          handleSort={handleSort}
        />

        <PageAPI
          page={bplist.page.number}
          size={bplist.page.size}
          totalElements={bplist.page.totalElements}
          totalPages={bplist.page.totalPages}
          loading={loading}
          onPageChange={(newPage) => setPage(prev => ({ ...prev, page: newPage }))}
          onPageSizeChange={(newSize) => setPage(prev => ({ ...prev, size: newSize }))}
        />


        {showModal && selectedBP && (
          <Dialog
            visible={showModal}
            onHide={closeModal}
            closeOnEscape={false}
            focusOnShow={false}
            header={
              <div className="flex justify-between gap-2 text-sm">
                <div className="flex gap-2">
                  <div className="bg-secondary text-secondary-foreground rounded-md px-2 py-1" >
                    {selectedBP.filialNome}
                  </div>
                  <div className="bg-primary text-primary-foreground rounded-md px-2 py-1" >
                    ({selectedBP.contaReduzido}) {selectedBP.contaDescricao}
                  </div>
                  <div className="bg-teal-600 text-white rounded-md px-2 py-1" >
                    ({selectedBP.centroCustoCodigo}) {selectedBP.centroCustoDescricao}
                  </div>
                  <div className="bg-muted text-foreground rounded-md px-2 py-1" >
                    {selectedBP.grupoDescricao}
                  </div>
                  <div className="bg-muted text-foreground rounded-md px-2 py-1" >
                    {selectedBP.contaTipo}
                  </div>
                  <div className="bg-muted text-foreground rounded-md px-2 py-1" >
                    {selectedBP.responsavelNome}
                  </div>

                </div>
                <div className="flex gap-2 px-3">
                  {selectedBP.compartilhado &&
                    <div className="bg-success/15 text-success rounded-md px-2 py-1" >
                      Compartilhado para: {selectedBP.usuarioCompartilhado}
                    </div>
                  }

                  {selectedBP.contaOrcada ?
                    <div className="bg-success/15 text-success rounded-md px-2 py-1" >
                      Realizado
                    </div>
                    :
                    <div className="bg-amber-400 text-amber-900 rounded-md px-2 py-1" >
                      Pendente
                    </div>
                  }
                </div>
              </div>
            }
            footer={
              <div className="flex gap-2 justify-between pt-3">
                <div>
                  <Button disabled={saving} label="Desmarcar Orçamento" onClick={desmarcarOrcamento} />
                </div>
                <div className="flex justify-end gap-2">
                  <Button
                    variant="gray"
                    disabled={saving}
                    label="Cancelar"
                    icon="fa fa-times"
                    onClick={closeModal} />
                  <Button
                    label={"Confirmar Alterações"}
                    disabled={saving}
                    icon="fa fa-thumbs-up"
                    loading={saving}
                    onClick={handleSave}
                    variant="indigo"/>
                </div>
              </div>
            }
            style={{ width: '98%', height: '98%', maxHeight: '200vw' }}
          >
            <div className="p-3">
              <h4 className="font-display text-lg font-semibold text-foreground mb-2">Orçamentos Mensais</h4>

              <div className="flex justify-between gap-4 mb-4">
                {showDistribuir ?
                  <form
                    className="flex gap-2 fade-in"
                    onSubmit={() => {
                      const total = parseFloat(valorDistribuir || 0);
                      const valorPorMes = total / MESES.length;
                      MESES.forEach((mes) => handleChangeValor2026(mes, parseFloat(valorPorMes.toFixed(2))));
                      setShowDistribuir(false);
                      setValorDistribuir("");
                    }}>

                    <InputNumber
                      ref={inputDistribuirRef}
                      value={formatNumber(valorDistribuir)}
                      onValueChange={(e) => setValorDistribuir(e.target.value)}
                      mode="decimal"
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      locale="pt-BR"
                      onFocus={(e) => e.target.select()}
                    />

                    <SplitButton
                      type="submit"
                      label="Confirmar"
                      icon="fas fa-check-circle"
                      variant="green"
                      className="btn-sm"
                      loading={false}

                      items={[
                        {
                          label: "Inserir por Mês",
                          icon: "fas fa-edit",
                          onClick: () => {
                            const total = parseFloat(valorDistribuir || 0);
                            MESES.forEach((mes) => handleChangeValor2026(mes, parseFloat(total.toFixed(2))));
                            setShowDistribuir(false);
                            setValorDistribuir("");
                          },
                        }
                      ]}
                    />

                    <Button
                      onClick={() => {
                        setShowDistribuir(false);
                        setValorDistribuir("");
                      }}
                      variant="gray"
                      label="Cancelar"
                      icon="fa fa-times"
                      className="btn-sm"
                    />

                  </form>
                  :
                  <div className="fade-in">
                    <Button
                      onClick={() => {
                        setShowDistribuir(true);

                        setTimeout(() => {
                          inputDistribuirRef.current?.focus();
                        }, 0);

                      }}
                      variant="indigo"
                      label="Distribuir Valores Mensais"
                      className="btn-sm"
                    />
                  </div>
                }

                {MESES.some((mes) => selectedBP.comparativo[mes].valor2026 > 0) && (
                  <Button
                    onClick={() => {
                      MESES.forEach((mes) => handleChangeValor2026(mes, 0));
                    }}
                    variant="red"
                    label="Zerar Valores 2026"
                    className="btn-sm"
                    icon="fa fa-trash"
                  />
                )}
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-8">
                {MESES.map((mes) => {
                  const { valor2025, valor2026, realizado2025 } = selectedBP.comparativo[mes];

                  let variacao = 0;

                  if (valor2025 > 0) {
                    variacao = (((valor2026 - valor2025) / valor2025) * 100).toFixed(2);
                  } else if (valor2025 === 0 && valor2026 > 0) {
                    variacao = "+100.00"
                  } else if (valor2025 === 0 && valor2026 === 0) {
                    variacao = "0.00";
                  } else {
                    variacao = "-100.00";
                  }

                  return (
                    <div key={mes} className="bg-muted p-3 rounded-lg">
                      <h5 className="text-sm font-medium text-foreground mb-1">{mes}</h5>

                      {/* Campo 2026 (editável) */}
                      <div className="flex gap-2 items-center mb-1">
                        <label className="text-xs text-muted-foreground w-10 pt-2">2026:</label>
                        <InputNumber
                          value={valor2026}
                          onValueChange={(e) => handleChangeValor2026(mes, e.value ?? 0)}
                          mode="decimal"
                          minFractionDigits={2}
                          maxFractionDigits={2}
                          locale="pt-BR"
                          onFocus={(e) => e.target.select()}
                        />
                      </div>

                      {/* Campo 2025 (somente leitura) */}
                      <div className="flex justify-between items-center vertical-middle">
                        <label className="text-xs text-muted-foreground w-10 pt-2">2025:</label>

                        <span className=" w-full px-2 py-1  rounded text-xs text-right text-foreground">
                          R$ {formatarMoedaBrasileira(valor2025) || '0,00'}
                        </span>
                      </div>

                      <div
                        className={`flex gap-2 justify-between  items-center vertical-middle rounded ${realizado2025 > valor2025 ? 'bg-destructive/10 text-destructive' : 'bg-muted'}`}
                      >
                        <label className="text-xs  w-10 pt-2">Realiz:</label>

                        <span className=" w-full px-2 py-1  rounded text-xs text-right">
                          R$ {formatarMoedaBrasileira(realizado2025) || '0,00'}
                        </span>
                      </div>

                      {/* Variação percentual */}
                      <div className="flex gap-2 justify-between items-center vertical-middle">
                        <label className="text-xs text-muted-foreground w-10 pt-2">Variação.Orç:</label>
                        <span
                          className={`text-xs font-medium text-right ${parseFloat(variacao) > 0
                            ? "text-destructive"
                            : parseFloat(variacao) < 0
                              ? "text-success"
                              : "text-foreground"
                            }`}
                        >
                          {variacao}%
                        </span>
                      </div>

                    </div>
                  );
                })}
              </div>

              {/* === COMPARATIVO TOTAL === */}
              <div className="bg-muted rounded-lg p-4 mb-6">
                {(() => {
                  const total2025 = selectedBP.total2025 || 0;
                  const total2026 = selectedBP.total2026 || 0;
                  let perc;
                  if (total2025 > 0) {
                    perc = (((total2026 - total2025) / total2025) * 100).toFixed(2);
                  } else if (total2025 === 0 && total2026 > 0) {
                    perc = "100.00";
                  } else if (total2025 === 0 && total2026 === 0) {
                    perc = "0.00";
                  } else {
                    perc = "-100.00";
                  }
                  const barWidth = Math.min(Math.abs(perc) + 50, 100);

                  return (
                    <>
                      <div className="flex justify-between items-center mb-4">
                        <div>
                          <h5 className="text-sm font-medium text-foreground">Ano Atual (2026)</h5>
                          <p className="font-display text-xl font-semibold text-primary">
                            R$ {total2026.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                          </p>
                        </div>
                        <div>
                          <h5 className="text-sm font-medium text-foreground">Ano Anterior (2025)</h5>
                          <p className="font-display text-xl font-semibold text-foreground">
                            R$ {total2025.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                          </p>
                        </div>
                        <div>
                          <h5 className="text-sm font-medium text-foreground">Comparativo</h5>
                          <p
                            className={`font-display text-xl font-semibold ${perc > 0
                              ? "text-destructive"
                              : perc < 0
                                ? "text-success"
                                : "text-foreground"
                              }`}
                          >
                            {perc === "∞" ? "Novo" : `${perc}%`}
                          </p>
                        </div>
                      </div>

                      <div className="h-4 bg-muted-foreground/20 rounded-full overflow-hidden">
                        <div
                          className={`h-full transition-all duration-150 ${perc > 0
                            ? "bg-destructive"
                            : perc < 0
                              ? "bg-success"
                              : "bg-muted-foreground/40"
                            }`}
                          style={{ width: `${barWidth}%` }}
                        ></div>
                      </div>
                    </>
                  );
                })()}
              </div>

              
            </div>

          </Dialog>
        )}

        <ImportarBPModal
          show={showModalImport}
          close={() => {
            setMensagemImportacao("");
            setShowModalImport(false)
          }}
          importarExcel={importarExcel}
          loadingImport={loadingImport}
          importMessage={mensagemImportacao}
        />
        <Modal
          title="Editar Conta BP"
          subtitle="Editar Gestor da Conta BP"
          isOpen={showModalEdit}
          width="w-[95%]"
          onClose={() => setShowModalEdit(false)}
        >
          <CadastroBP setShowModal={setShowModalEdit} modo="editar" bpSelecionado={selectedBP} />
        </Modal>

        <Modal
          isOpen={showModalDespesa}
          title={
            viewMode === "lista"
              ? "Despesas - "
              : "Lançamento Detalhado"
          }
          subtitle={""
          }
          onClose={fecharModal}
          footer={
            <div className="flex justify-between items-center">
              <div className="text-sm text-muted-foreground">
                {viewMode === "lista" && (
                  <>
                    Total: <span className="font-medium">R$ {formatarMoedaBrasileira(valorTotalDespesa)}</span>
                  </>
                )}
                {viewMode === "nota" && (
                  <>
                    Total da Nota:&nbsp;
                    <span className="font-medium">
                      R$ {formatarMoedaBrasileira(
                        nota.reduce((acc, item) => acc + (item.valor || 0), 0)
                      )}
                    </span>
                  </>
                )}
              </div>

              <div className="flex gap-2">
                {viewMode === "nota" && (
                  <Button
                    label="Voltar"
                    variant="gray"
                    onClick={voltarLista}
                  />
                )}
                <Button
                  label="Fechar"
                  variant="indigo"
                  onClick={fecharModal}
                />
              </div>
            </div>
          }
        >
          <div className="overflow-x-auto">
            {viewMode === "lista" ? (
              // === TABELA DE DESPESAS ===
              <table className="w-full">
                <thead className="bg-table-header">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider">Data</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider">Histórico</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider">Centro Custo</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider">Conta Contábil</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-table-header-fg uppercase tracking-wider">Valor</th>
                    <th className="px-4 py-3 text-center text-xs font-medium text-table-header-fg uppercase tracking-wider">Ver Lançamento</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-table-border">
                  {loadingDespesa ? (
                    <tr><td colSpan={6}><Loading /></td></tr>
                  ) : listaDespesa.length > 0 ? (
                    (() => {
                      const grouped = {};
                      listaDespesa.forEach((item) => {
                        const date = new Date(item.data);
                        const key = date.toLocaleString('pt-BR', { month: 'long', year: 'numeric' });
                        if (!grouped[key]) grouped[key] = [];
                        grouped[key].push(item);
                      });

                      return Object.entries(grouped).map(([mes, despesas], i) => (
                        <React.Fragment key={i}>
                          <tr>
                            <td colSpan={6} className="bg-muted text-foreground font-semibold px-4 py-2">
                              {mes.charAt(0).toUpperCase() + mes.slice(1)}
                            </td>
                          </tr>
                          {despesas.map((data, j) => (
                            <tr key={`${i}-${j}`} className="fade-in">
                              <td className="px-4 py-3 text-sm text-muted-foreground">{returnDate(data.data)}</td>
                              <td className="px-4 py-3 text-sm text-foreground">{data.historico}</td>
                              <td className="px-4 py-3 text-sm text-muted-foreground text-center">{data.centroCustoCodigo}</td>
                              <td className="px-4 py-3 text-sm text-muted-foreground text-center">{data.contaContabilReduzido}</td>
                              <td className="px-4 py-3 text-left text-sm font-medium text-foreground">R$ {formatarMoedaBrasileira(data.valor)}</td>
                              <td className="px-4 py-3 text-sm text-primary text-center cursor-pointer hover:underline"
                                onClick={() => abrirNotaCompleta(data.historico, data.data)}>
                                Ver Lançamento
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ));
                    })()
                  ) : (
                    <tr><td colSpan={6} className="text-center text-muted-foreground py-4">Nenhuma despesa encontrada.</td></tr>
                  )}
                </tbody>
              </table>
            ) : (
              // === TABELA DE NOTA DETALHADA ===
              <table className="w-full">
                <thead className="bg-table-header">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider">Data</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider">Histórico</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider">Centro Custo</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider">Conta Contábil</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-table-header-fg uppercase tracking-wider">Valor</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-table-border">
                  {loadingDespesa ? (
                    <tr><td colSpan={5}><Loading /></td></tr>
                  ) : nota.length > 0 ? (
                    nota.map((item, i) => (
                      <tr key={i}>
                        <td className="px-4 py-3 text-sm text-muted-foreground">{returnDate(item.data)}</td>
                        <td className="px-4 py-3 text-sm text-foreground">{item.historico}</td>
                        <td className="px-4 py-3 text-sm text-muted-foreground text-center">{item.centroCustoCodigo}</td>
                        <td className="px-4 py-3 text-sm text-muted-foreground text-center">{item.contaContabilReduzido}</td>
                        <td className="px-4 py-3 text-left text-sm font-medium text-foreground">R$ {formatarMoedaBrasileira(item.valor)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan={5} className="text-center text-muted-foreground py-4">Nenhum lançamento encontrado.</td></tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </Modal>
      </div>
    </div>
  );
}